import React from "react";

const RadioButton = ({ label, value, selectedOption, onChange, groupName }) => {
  return (
    <label className="flex items-center">
      <input
        type="radio"
        name={groupName}
        value={value}
        checked={selectedOption === value}
        onChange={onChange}
        className="mr-2 cursor-pointer h-4 w-4"
      />
      <p className="text-[12px] mr-1 cursor-pointer">{label}</p>
    </label>
  );
};

export default RadioButton;
